import { useLogin } from '@bnnvara/accounts';
import PropTypes from 'prop-types';
import React from 'react';

import useSharedRef from '../../../hooks/useSharedRef';
import ProfileHeaderLoading from './ProfileHeaderLoading';
import ProfileHeaderLoggedIn from './ProfileHeaderLoggedIn';
import ProfileHeaderLoggedOut from './ProfileHeaderLoggedOut';

const ProfileHeader = ({ page }) => {
  const { isLoggedIn, status } = useLogin();
  const { createRef } = useSharedRef();
  const ref = createRef('profileHeader');
  const textColor = 'white';

  if (status === 'loading')
    return <ProfileHeaderLoading textColor={textColor} ref={ref} page={page} />;

  if (isLoggedIn)
    return (
      <ProfileHeaderLoggedIn textColor={textColor} ref={ref} page={page} />
    );

  return <ProfileHeaderLoggedOut page={page} />;
};

ProfileHeader.defaultProps = {
  page: {
    callToActionText: null,
    callToActionUrl: null,
  },
};
ProfileHeader.propTypes = {
  page: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    backgroundImage: PropTypes.string.isRequired,
    backgroundImageMobile: PropTypes.string.isRequired,
    logoUrl: PropTypes.string.isRequired,
    callToActionText: PropTypes.string,
    callToActionUrl: PropTypes.string,
  }),
};

export default ProfileHeader;
